module.exports = __webpack_public_path__ + "1e8956b751d44a7f8842caa77eb9542e.svg";